<template>
  <!-- 分配用户的对话框 -->
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>Basic data</el-breadcrumb-item>
      <el-breadcrumb-item>Agent Info</el-breadcrumb-item>
      <el-breadcrumb-item>Parameter Setting</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack" content="Parameter Setting"></el-page-header>
    <el-divider></el-divider>
    <!-- 卡片视图区域 -->
    <el-card style="height: 800px">
      <div style="margin-bottom: 20px;">
        <el-button
          v-hasPermission="['agencyAgreement:save']"
          v-if="isShowGroupBtn && canSave "
          icon="el-icon-circle-plus"
          size="small"
          @click="addGroup()"
        >Add Group</el-button>
      </div>
      <el-row>
        <el-col :span="3">
          <el-tree
            node-key="id"
            class="filter-tree"
            :data="treeData"
            :props="defaultProps"
            :default-expand-all="false"
            ref="tree"
            @node-click="handleNodeClick"
            :default-expanded-keys="expandKeys"
            :expand-on-click-node="false"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <span>
                <el-button
                  v-if="canSave "
                  v-hasPermission="['agencyAgreement:delete']"
                  type="text"
                  size="mini"
                  @click="() => deleteGroup(node, data)"
                >Delete</el-button>
              </span>
            </span>
          </el-tree>
        </el-col>

        <el-col :span="21">
          <el-card v-if="currentParentId != null ">
            <el-row>
              <el-col class="group_header">{{groupHeaderTitle}}</el-col>
            </el-row>
            <el-row>
              <el-form :model="aggrement" ref="agreementForm" :rules="aggrementFormRules">
                <el-col :span="8">
                  <el-form-item
                    label="Group Name"
                    label-width="170px"
                    prop="groupName"
                  >
                  <el-input
                    @change="handleChange"
                    type="number"
                    v-model="aggrement.groupName"
                    style="width:80%"
                  >
                  </el-input>
                    kPa
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="Remark"
                    label-width="160px"
                    prop="Remark"
                  >
                    <el-input
                      placeholder=""
                      maxlength="30"
                      v-model="aggrement.remark"
                    ></el-input>
                  </el-form-item>
                </el-col>
                   <el-col :span="8">
                  <el-form-item
                    label="Test Type"
                    label-width="160px"
                    prop="testType"
                  >
                    <el-select
                      v-model="aggrement.testType"
                      placeholder=""
                    >
                      <el-option
                        v-for="item in selectTypeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col>
                  <el-form-item label="Agreement:" label-width="160px" prop="agreement">
                    <el-input type="textarea" autosize placeholder v-model="aggrement.agreement"></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
            </el-row>
            <el-row type="flex" justify="end" v-if="currentParentId == null && currentParentId <0">
              <el-col :span="3">
                <el-button
                  v-hasPermission="['agencyAgreement:save']"
                  icon="el-icon-check"
                  size="small"
                  @click="saveAggrement()"
                >Save Aggrement</el-button>
              </el-col>
            </el-row>

            <el-row type="flex" justify="end">
              <el-col class="searchBtns" :span="6">
                <el-button-group>
                  <el-button
                    v-hasPermission="['agencyAgreement:save']"
                    v-if="currentParentId != null && canSave"
                    icon="el-icon-check"
                    size="small"
                    @click="saveAggrement()"
                  >Save Aggrement</el-button>
                  <el-button
                    v-hasPermission="['agentOption:save']"
                    plain
                    size="small"
                    icon="el-icon-circle-plus"
                    v-if="currentParentId != null && currentParentId >0 && isShowRoundBtn && canSave"
                    @click="showAddDialog"
                  >Add Round</el-button>
                  <el-button
                    v-hasPermission="['agentOption:batchDelete']"
                    plain
                    size="small"
                    icon="el-icon-remove"
                    v-if="currentParentId != null && currentParentId >0 && canSave"
                    @click="deletes"
                  >Delete Round</el-button>
                </el-button-group>
              </el-col>
            </el-row>

            <!-- 列表区域 -->
            <el-table
              v-if="currentParentId != null && currentParentId >0 "
              :data="dataList"
              border
              stripe
              @selection-change="handleSelectionChange"
              @sort-change="sortChange"
              align="center"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column label="Round" prop="roundId" width="100px"></el-table-column>
              <el-table-column label="Group pressure(kPa)" prop="startPressure"></el-table-column>
              <el-table-column label="Test duration(s)" prop="testTime"></el-table-column>
              <el-table-column label="prompt overpressure value(kPa)" prop="overpressure"></el-table-column>
              <el-table-column
                label="Exceed allowable starting pressure value(kPa)"
                prop="cannotpressureNum"
              ></el-table-column>
              <el-table-column label="Whether as a criterion" prop="decisionStandard">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.decisionStandard==='Y'" type="success">Yes</el-tag>
                  <el-tag v-else-if="scope.row.decisionStandard==='N'" type="info">No</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="Allowable pressure reduction range(kPa)"
                prop="pressureDecRange"
              ></el-table-column>>
              <el-table-column label="Operate" width="130px" v-if="canSave">
                <template slot-scope="scope">
                  <el-link
                    v-hasPermission="['agentOption:save']"
                    icon="el-icon-edit-outline"
                    @click="showEditDialog(scope.row.id)"
                  >Edit</el-link>
                </template>
              </el-table-column>
            </el-table>

            <!-- 分页区域 -->
            <el-pagination
              v-if="currentParentId != null && currentParentId >0 "
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="queryInfoparams.current"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="queryInfoparams.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </el-card>
        </el-col>
      </el-row>
    </el-card>

    <!-- 添加角色的对话框 -->
    <el-dialog :visible="addDialogVisible" width="60%" @close="closeDialog" slot="title">
      <template slot="title">
        <div>
          <h3>{{dialogTitle}}</h3>
          <el-divider style="font-weight: bold"></el-divider>
        </div>
      </template>
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="250px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="RoundId" prop="roundId" align="center">
              <el-input v-model="addForm.roundId" type="number"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Group pressure(kPa)" prop="startPressure">
              <el-input v-model="addForm.startPressure" type="number"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="Test duration(s)" prop="testTime">
              <el-input v-model="addForm.testTime" type="number"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="prompt overpressure value(kPa)" prop="overpressure">
              <el-input v-model="addForm.overpressure" type="number"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="Exceed allowable starting pressure value(kPa)"
              prop="cannotpressureNum"
            >
              <el-input v-model="addForm.cannotpressureNum" type="number"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Whether as a criterion" prop="decisionStandard">
              <el-select v-model="addForm.decisionStandard" placeholder="please select">
                <el-option label="Yes" value="Y"></el-option>
                <el-option label="No" value="N"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="Allowable pressure reduction range(kPa)" prop="pressureDecRange">
              <el-input v-model="addForm.pressureDecRange" type="number"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Allow boost range(kPa)" prop="pressureRiseRange">
              <el-input v-model="addForm.pressureRiseRange" type="number"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="saveRound">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      // 获取用户列表的参数对象
      queryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
      },
      // 控制添加 对话框的显示与隐藏
      addDialogVisible: false,
      //列表
      dataList: [],
      total: 0,
      //角色用户列表的checkbox值
      multipleSelection: [],
      //搜索列表的checkbox值
      multipleSelectionSearch: [],
      //搜索用户列表
      searchDataList: [],

      searchTotal: 0,
      treeName: this.$route.query.treeName + ' 树形列表',
      agentId: this.$route.query.agentId,

      //当前点击的树节点ID，默认是-1第一层
      currentParentId: null,
      //搜索内容
      searchContent: null,

      filterText: '',
      //树列表 数据
      treeData: [],
      //展开的节点数组
      expandKeys: [-1],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      selectTypeOptions: [],
      //新增
      addForm: {
        status: 'Y',
      },
      // 添加表单的验证规则对象
      addFormRules: {
        roundId: [
          { required: true, message: 'Round can not be null', trigger: 'blur' },
        ],
        startPressure: [
          {
            required: true,
            message: 'Group pressure can not be null',
            trigger: 'blur',
          },
        ],
        testTime: [
          {
            required: true,
            message: 'Test duration can not be null',
            trigger: 'blur',
          },
        ],
        overpressure: [
          {
            required: true,
            message: 'overpressure value can not be null',
            trigger: 'blur',
          },
        ],
        cannotpressureNum: [
          {
            required: true,
            message: 'starting value can not be null',
            trigger: 'blur',
          },
        ],
        decisionStandard: [
          { required: true, message: 'please select', trigger: 'blur' },
        ],
        pressureDecRange: [
          {
            required: true,
            message: 'reduction range can not be null',
            trigger: 'blur',
          },
        ],
        pressureRiseRange: [
          {
            required: true,
            message: 'boost range can not be null',
            trigger: 'blur',
          },
        ],
      },

      aggrementFormRules: {
        groupName: [
          {
            required: true,
            message: 'please enter group name',
            trigger: 'blur',
          },
        ],
        testType: [
          {
            required: true,
            message: 'please choose the test type',
            trigger: 'blur',
          },
        ],
        agreement: [
          {
            required: true,
            message: 'please enter agreement content',
            trigger: 'blur',
          },
          {
            max:1000,
            message: 'content too long',
            trigger: 'blur',
          },
        ],
      },

      aggrement: {
        id: null,
        agencyId: this.agentId,
        groupName: '',
        testType: '',
        agreement: '',
      },
      visible: this.$route.query.visible,
      testStandard: this.$route.query.testStandard,

      dialogTitle: '',
      groupHeaderTitle: '',

      //判断是否第一次进去页面加载
      firstLoad: true,

      //组不能超过10个，否则不显示新增按钮
      isShowGroupBtn: true,

      //是否允许保存
      canSave: false,

      //轮不能超过5个，否则不显示新增按钮
      isShowRoundBtn: true,
    }
  },
  created() {
    this.getTreeData()
    this.getTestType()

    console.log('testStandard==', this.testStandard)
    console.log('visible==', this.visible)

    //总部权限的人员，可以修改保存
    //代理商人员只有
    if (this.visible == 'true') {
      //总部权限

      this.canSave = true
    } else {
      //代理商权限
      //个性化允许修改
      if (this.testStandard == 'PERSONAL') {
        this.canSave = true
      } else {
        this.canSave = false
      }
    }

    console.log('canSave==', this.canSave)
  },
  methods: {
    //导出excel
    exportExcel() {
      console.log('-----------')
      var params = { treeId: this.treeId }

      let res = this.$export(
        'tree/item/exportExcel',
        JSON.stringify(params),
        'tree'
      )
    },
    addGroup() {
      let count = this.treeData.length + 1
      const newChild = { id: -count, label: 'Group' + count }
      this.currentParentId = -count
      console.log('currentParentId==', this.currentParentId)
      this.treeData.push(newChild)
      if (count >= 10) {
        this.isShowGroupBtn = false
      } else {
        this.isShowGroupBtn = true
      }
      //切换表单
      this.handleNodeClick(newChild)
    },

    //监听字段排序
    sortChange(r) {
      //设置排序字段名
      this.queryInfoparams.sortField = r.prop
      //设置排序字段名
      this.queryInfoparams.sortOrder = r.order

      this.getDataList()
    },
    getEntity(aggrementId) {
      this.$get(`/agencyAgreement/getAgreement/${aggrementId}`).then(
        ({ data: res }) => {
          if (res.ok) {
            this.aggrement = res.data
          }
        }
      )
    },
    // 获取 查询用户数据列表
    getDataList() {
      // 分页查询用户
      this.queryInfoparams.params.agentId = this.agentId
      this.queryInfoparams.params.groupId = this.currentParentId
      this.$post(
        '/agencyDeviceOption/queryDeviceOptionByGroup',
        this.queryInfoparams
      ).then(({ data: res }) => {
        this.dataList = res.records
        this.total = res.total

        //大于5条，不允许新增
        if (this.dataList >= 5) {
          this.isShowRoundBtn = false
        } else {
          this.isShowRoundBtn = true
        }
      })
    },
    getTreeData() {
      this.$get(`agencyAgreement/getGroupTree/${this.agentId}`).then(
        ({ data: res }) => {
          // console.log(res)
          this.treeData = res.data

          if (this.treeData.length >= 10) {
            this.isShowGroupBtn = false
          } else {
            this.isShowGroupBtn = true
          }
          if (this.firstLoad) {
            if (this.treeData.length > 0) {
              this.handleNodeClick(this.treeData[0])
            }
            this.firstLoad = false
          } else {
            if (this.treeData.length > 0) {
              var node = {
                id: this.currentParentId,
                label: this.groupHeaderTitle,
              }
              this.handleNodeClick(node)
            } else {
              this.aggrement = {}
              this.dataList = []
              this.total = 0
              this.currentParentId = null
            }
          }
        }
      )
    },
    // 获取 testType可选择的项
    getTestType() {
      this.$get(`dict/getByTypeCode/TEST_TYPE/Y`).then(({ data: res }) => {
        for (let i in res.data) {
          res.data[i].label = res.data[i].item_name
          res.data[i].value = res.data[i].item_code
        }
        this.selectTypeOptions = res.data
      })
    },
    handleNodeClick(data) {
      console.log(data.id)
      this.groupHeaderTitle = data.label
      if (data.id == undefined || data.id == null || data.id < 0) {
        this.currentParentId = data.id
        this.aggrement = {}
        this.dataList = []
        this.total = 0
      } else {
        this.currentParentId = data.id
        this.getEntity(this.currentParentId)
        this.getDataList()
      }
    },
    showAddDialog() {
      this.addDialogVisible = true
      this.dialogTitle = 'Add Round'
    },
    showEditDialog(id) {
      this.addDialogVisible = true
      this.dialogTitle = 'Edit Round'
      this.$get(`agencyDeviceOption/get/${id}`).then(({ data: res }) => {
        console.log(res)
        this.addForm = res.data
      })
    },
    closeDialog() {
      this.addForm = {}
      this.addDialogVisible = false
    },
    // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getDataList()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getDataList()
    },
    // 监听对话框的关闭事件
    goBack() {
      this.$router.back()
    },
    // 点击按钮 新增保存协议
    async saveAggrement() {
      this.$refs.agreementForm.validate(async (valid) => {
        this.aggrement.agencyId = this.agentId
        //父级ID
        if (!valid) return
          const loading = this.$loading({
            lock: true,
            text: 'Saving',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
        this.$post('agencyAgreement/save', this.aggrement).then(
          ({ data: res }) => {
            if (res.ok) {
              // 刷新列表数据
              this.getDataList()
              this.getTreeData()
              this.currentParentId = res.data.id
              var node = {
                id: this.currentParentId,
                label: this.groupHeaderTitle,
              }
              this.handleNodeClick(node)
              loading.close()
              return this.$message.success(res.msg)
            } else {
              loading.close()
              this.$message.error(res.msg)
            }
          }
        ) 
        .catch(r => {
          console.error(r)
          loading.close()
        })
      })
    },

    //保存
    async saveRound() {
      this.$refs.addFormRef.validate(async (valid) => {
        this.addForm.agencyId = this.agentId
        this.addForm.groupId = this.currentParentId
        this.addForm.testType = this.aggrement.testType
        //父级ID
        if (!valid) return
          const loading = this.$loading({
            lock: true,
            text: 'Saving',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
        this.$post('agencyDeviceOption/save', this.addForm).then(
          ({ data: res }) => {
            if (res.ok) {
              // 刷新列表数据
              this.getDataList()
              this.closeDialog()
              loading.close()
              return this.$message.success(res.msg)
            } else {
              loading.close()
              this.$message.error(res.msg)
            }
            
          }
        ) 
        .catch(r => {
          console.error(r)
          loading.close()
        })
      })
    },

    //监控checkbox的选择,为entity的所有值
    handleSelectionChange(val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
    },

    //监控搜索页面 checkbox的选择,为entity的所有值
    handleSelectionChangeSearch(val) {
      this.multipleSelectionSearch = val
      console.log(this.multipleSelectionSearch)
    },
    // 删除组
    async deleteGroup(node, data) {
      const groupId = data.id

      if (groupId < 0) {
        this.getTreeData()
        return
      }

      // 弹框询问用户是否删除
      const confirmResult = await this.$confirm(
        'it is will delete group,dou you continute?',
        'delete group',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      )
        .then(() => {
          //同意
          this.$delete(`agencyAgreement/deleteGroup/${groupId}`).then(
            ({ data: res }) => {
              if (!res.ok) {
                return this.$message.error(res.msg)
              }
              this.$message.success(res.msg)

              this.getTreeData()
            }
          )
        })
        .catch(() => {})
    },
    // 批量删除轮数
    async deletes() {
      if (
        this.multipleSelection == null ||
        this.multipleSelection.length <= 0
      ) {
        return this.$message.error('please select one record !')
      }

      var ids = []
      this.multipleSelection.forEach((row) => {
        ids.push(row.id)
      })

      console.log(ids)

      // 弹框询问用户是否删除
      const confirmResult = await this.$confirm(
        'it is will delete,dou you continute?',
        'delete round',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      )
        .then(() => {
          this.$delete(`agencyDeviceOption/batchDelete`, { idList: ids }).then(
            ({ data: res }) => {
              if (!res.ok) {
                return this.$message.error(res.msg)
              }
              this.$message.success(res.msg)

              this.getDataList()
            }
          )
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="less" scoped>
.rightContent {
  display: flex;
  .el-input {
    margin-right: 10px;
  }
}
.el-select {
  width: 100%;
}

/deep/.el-collapse-item__content {
  display: flex;
  justify-content: space-between;
}

.searchBtns {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

/deep/.el-collapse-item__wrap {
  border: none !important;
}
/deep/.el-collapse-item__header {
  border: none !important;
}

.el-row {
  flex: 1;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.group_header {
  font-weight: bold;
  margin-bottom: 20px;
}
</style>